export default "__VITE_ASSET__b34c80bb__"